import React from 'react';
import { GenericEntry } from '../..';
import { User } from '../../../../../entities/User';
import { SendEmailTrigger } from '../../../../../entities/applicant_tracking/Trigger';
import { Application } from '../../../../../entities/Application';
import {
  TriggerActions,
  TriggerExecutionCancelReason,
} from '../../../../../entities/ApplicationFeed';
import { AlertObject } from '../../../../../components/Alert';

interface PropTypes {
  application: Application;
  currentUser: User;
  entry: TriggerActions;
  isLastItemInPage: boolean;
  setAlert: (data: AlertObject) => void;
  reloadFeed: () => void;
}

export function TriggerEmailCancelled(props: PropTypes) {
  const trigger = props.entry.trigger as SendEmailTrigger;
  const { cancelledByName, cancelReason } = props.entry.triggerExecution;

  const statusComponentMap: Partial<
    Record<TriggerExecutionCancelReason, string>
  > = {
    auto_reject: 'an automatic rejection',
    move_to_stage: 'the most recent stage move',
    rejection: 'a candidate rejection',
    feed_action: cancelledByName,
  };

  return (
    <>
      <GenericEntry
        icon='bi-envelope-x'
        iconClassName='bg-light-danger'
        title={
          <>
            An automatic e-mail with the template{' '}
            <strong>{trigger.emailTemplateName}</strong> has been cancelled by{' '}
            <strong>
              {statusComponentMap[cancelReason] ?? cancelledByName}
            </strong>
            .
          </>
        }
        date={props.entry.createdAt}
        {...props}
      ></GenericEntry>
    </>
  );
}
